var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: _vm.$route.name, query: { q: (_vm.attribute + " " + _vm.setDirection) } }},nativeOn:{"click":function($event){_vm.$emit('changeQ', _vm.$route.query.q)}}},[_vm._v("\n  "+_vm._s(_vm.I18n.t(_vm.name))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-348559df","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/sort_link.vue
// module id = 368
// module chunks = 0 1 2 3 4 5 6 7 8 10 82 85 90 93 94 102 104 108 116 348